import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import Home from '../views/Home.vue'

Vue.use(Router);
Vue.use(Meta);

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/videos/',
			name: 'videos',
			component: () => import(/* webpackChunkName: "SeriesList" */ '../views/SeriesList.vue')
		},
		{
			path: '/videos/:seriesId-:seriesName',
			name: 'series',
			component: () => import(/* webpackChunkName: "Series" */ '../views/Series.vue')
		},
		{
			path: '/videos/:seriesId-:seriesName/:categoryId-:categoryName',
			name: 'category',
			component: () => import(/* webpackChunkName: "Series" */ '../views/Series.vue')
		},
		{
			path: '/soundtracks/',
			name: 'soundtracks',
			component: () => import(/* webpackChunkName: "Soundtracks" */ '../views/Soundtracks.vue')
		},
		{
			path: '/video/:id-:name',
			name: 'video',
			component: () => import(/* webpackChunkName: "Video" */ '../views/Video.vue')
		},
		{
			path: '/Video/',
			name: 'video-old',
			component: () => import(/* webpackChunkName: "Video" */ '../views/Video.vue')
		},
		{
			path: '/account',
			name: 'account',
			component: () => import(/* webpackChunkName: "Account" */ '../views/Account')
		},
		{
			path: '/privacy',
			name: 'privacy',
			component: () => import(/* webpackChunkName: "Privacy" */ '../views/Privacy')
		},
		{
			path: '/sub',
			name: 'sub',
			component: () => import(/* webpackChunkName: "SubtitleSuite" */ '../views/experiment/SubtitleSuite')
		},
	]
})
